import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrganizationApi } from "../../../../../../services/Api/types";

interface Props {
	organization: OrganizationApi;
}

const OrganizationFinancialCard = ({ organization }: Props) => {
	const { t } = useTranslation("admin");

	const drawMrr = () => {
		let result = FormatMoney(organization.mrr);
		if (organization.subscription_count) {
			result += ` / ${t("modules.organization.field.subscriptions.title", {
				count: organization.subscription_count,
			})}`;
		}
		return result;
	};

	const drawMrrSum = () => {
		let result = FormatMoney(organization.mrr_sum);

		if (organization.payment_count) {
			result += ` / ${t("modules.organization.field.payments.title", {
				count: organization.payment_count,
			})}`;
		}
		return result;
	};

	return (
		<Card className="financial-card">
			<Card.Body>
				<h5>{t("modules.organization.field.finances.title")}</h5>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.mrr")}</span>
						<span>{drawMrr()}</span>
					</div>
				</div>
				{organization.first_paid_at && (
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("common.word.first_paid_at")}</span>
							<span>{FormatDate(organization.first_paid_at)?.split(",")[0]}</span>
						</div>
					</div>
				)}
				{organization.mrr_sum && (
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("common.word.mrr_sum")}</span>
							<span>{drawMrrSum()}</span>
						</div>
					</div>
				)}
			</Card.Body>
		</Card>
	);
};
export default OrganizationFinancialCard;
